import React, { PropTypes } from 'react';
import MenuItem from './MenuItem';
import { browserHistory } from 'react-router';
import CSSTransitionGroup from 'react-addons-css-transition-group';
import { trUri } from '../utils';

const goTo = (showSection, uri) => {
  browserHistory.push(uri);
  showSection();
};

const SubMenu = ({ items, lang, onClick, navOnly }) => (
  <ul style={{ position: 'absolute' }}>
    <CSSTransitionGroup
      transitionName="menuitem"
      transitionEnterTimeout={500}
      transitionLeaveTimeout={500}
    >
      {navOnly || items.map((menuitem, i) =>
        <div key={i}>
          <MenuItem
            className="menuitem submenuitem"
            lang={lang}
            item={menuitem}
            onClick={() => goTo(onClick, `/${lang}${trUri(menuitem, lang)}`)}
          />
          <div className="underlinemainnav" />
        </div>)}
    </CSSTransitionGroup>
  </ul>
);


SubMenu.propTypes = {
  items: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  navOnly: PropTypes.bool.isRequired,
};

export default SubMenu;



// WEBPACK FOOTER //
// ./common/components/SubMenu.js